import { render, staticRenderFns } from "./StatusToogle.vue?vue&type=template&id=67a52bd6&"
import script from "./StatusToogle.vue?vue&type=script&lang=js&"
export * from "./StatusToogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports